import React from "react";
type BaseCheckboxProp = {
  children: any;
  labelClasses: string;
  id: string;
  disabled: boolean;
  checked: boolean;
  change: (e:any) => void;
};
const BaseCheckbox: React.FC<BaseCheckboxProp> = ({
  children,
  labelClasses,
  id,
  disabled = false,
  checked = false,
  change,
}) => {
  return (
    <div className="md-checkbox center_align_row matte">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={change}
      />
      <label htmlFor={id} className={`${labelClasses} mt-1`}>
        {children}
      </label>
    </div>
  );
};

export default BaseCheckbox;
